angular.module('pe4h').run(['$templateCache', function($templateCache) {
  $templateCache.put('components/projects/project-client.html',
    '<!-- Project contact info: TODO: Load contact info based on project info and user proposal etc-->\n' +
    '<div ng-controller="ProjectClient" ng-init="init()" ng-cloak>\n' +
    '    <div ng-if="client">\n' +
    '        <!-- Client -->\n' +
    '        <ul class="list-inline user-request mt25" >\n' +
    '            <li class="user-profile-photo">\n' +
    '                <div class="user-photo" style="background-image:url({{client.Picture.Url}}),url(assets/img/avatar.png);"></div>\n' +
    '            </li>\n' +
    '            <li>\n' +
    '                <h4 ng-show="client.FullName">{{client.FirstName}} {{client.LastName.substring(0,1)}}.</h4>\n' +
    '                <address style="min-height:65px;">\n' +
    '                    <i ng-show="client.City || client.State" class="fa fa-map-marker fa-fw"></i>\n' +
    '                    <span ng-show="client.City">{{client.City}}, </span>{{client.State}}\n' +
    '                    <br>\n' +
    '                    <i ng-if="user && user.IsProfessional && alreadyHired() && clientData.Email" class="fa fa-envelope fa-fw"></i>\n' +
    '                        <span ng-if="user && user.IsProfessional && alreadyHired() && clientData.Email">{{clientData.Email}}</span>\n' +
    '                    <br>\n' +
    '                    <i ng-if="user && user.IsProfessional && alreadyHired() && clientData.Phone" class="fa fa-phone fa-fw"></i>\n' +
    '                        <span ng-if="user && user.IsProfessional && alreadyHired() && clientData.Phone">{{clientData.Phone}}</span>\n' +
    '                    <i ng-if="user && user.IsProfessional && alreadyHired() && !clientData.Phone" class="fa fa-phone fa-fw"></i>\n' +
    '                        <span ng-if="user && user.IsProfessional && alreadyHired() && !clientData.Phone">Not provided</span>\n' +
    '                    <div ng-show="::hired || project.IsPublic">\n' +
    '                        <i ng-show="clientData.WebSite" class="fa fa-phone fa-globe fa-fw"></i>\n' +
    '                        <a ng-href="//{{clientData.WebSite}}" target="_blank">{{clientData.WebSite}}</a>\n' +
    '                    </div>\n' +
    '                </address>\n' +
    '            </li>\n' +
    '        </ul>\n' +
    '\n' +
    '        <!-- Statistics -->\n' +
    '        <div class="row" ng-if="!user || (user.IsProfessional && myProposal == null)">\n' +
    '            <div class="col-xs-4 stats">\n' +
    '                <a><i class="fa fa-tag fa-flip-horizontal"></i>{{project.ProposalsCount}}<span ng-show="!project.IsPublic">/5</span></a>\n' +
    '                proposals submitted\n' +
    '            </div>\n' +
    '            <div class="col-xs-8 stats" ng-if="project.expired">\n' +
    '                <a><i class="fa fa-clock-o"></i><span>project expired</span></a>\n' +
    '            </div>\n' +
    '        </div>\n' +
    '\n' +
    '        <div class="row" ng-if="user.IsProfessional && myProposal != null">\n' +
    '            <div class="col-xs-4 stats">\n' +
    '                <a><i class="fa fa-tag fa-flip-horizontal"></i>{{project.ProposalsCount}}<span ng-show="!project.IsPublic">/5</span></a>\n' +
    '                total quotes\n' +
    '            </div>\n' +
    '            <!--div class="col-xs-4 stats">\n' +
    '                <a><i class="fa fa-usd"></i>4</a>\n' +
    '                credits\n' +
    '            </div-->\n' +
    '            <div class="col-xs-8 stats alt">\n' +
    '                <a><i class="fa fa-calendar-check-o"></i>{{myProposal.CreatedDate|standardMonthDayYear}}</a>\n' +
    '                proposal sent\n' +
    '            </div>\n' +
    '        </div>\n' +
    '    </div>\n' +
    '</div>\n' +
    '');
}]);
